module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Cb-Db-Ec.b8842ba1.png";